<svelte:head>
<style>
    @import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
    @import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Raleway:ital,wght@0,100..900;1,100..900&display=swap');
  /*
    @font-face {
        font-family: 'YourFontNameHere';
        src: url('/static/fonts/Kunika.otf') format('opentype');
    }

   */
    /*
    body {
        font-family: 'YourFontName', fallbackFont, sans-serif;
    }*/
  h1, h2, h3, p, button, input, textarea {
      font-family:  "Poppins", sans-serif;
  }
  body {
      --bg-1: black;
      --bg-2: hsl(241, 93%, 67%);
      --bg-3: hsl(303, 60%, 35%);
      --fg-1: black;
      --fg-2: hsl(0, 0%, 20%);
      --fg-3: hsl(0, 0%, 30%);
      --link: hsl(208, 77%, 47%);
      --link-hover: hsl(208, 77%, 55%);
      --link-active: hsl(208, 77%, 40%);
      --border-radius: 4px;
      --font: "Poppins", sans-serif;
      --font-mono: "Raleway", sans-serif;
      background: var(--bg-1);
      color: var(--fg-1);
      font-family: var(--font);
      line-height: 1.5;
      margin: 1rem;
      height: calc(100vh - 2rem);
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
      font-weight: normal;
      font-variant-numeric: tabular-nums;
      line-height: 1.1;
  }

  /*:is(h1, h2, h3, h4, h5, h6, p) {*/
  /*    margin: 1rem 0.1rem;*/
  /*}*/

  label {
      margin: 0.5rem 0.1rem;
  }

  :is(h1, h2, h3, h4, h5, h6, p, label):first-child {
      margin-top: 0;
  }

  :is(h1, h2, h3, h4, h5, h6, p, label):last-child {
      margin-bottom: 0;
  }

  a {
      color: var(--link);
  }

  a:hover {
      color: var(--link-hover);
  }

  a:active {
      color: var(--link-active);
  }

  label {
      display: flex;
      gap: 0.5rem;
      align-items: center;
  }

  label input {
      margin: 0;
  }

  button,
  input,
  select {
      font-family: inherit;
      font-size: inherit;
  }

  button {
      background: var(--link);
      color: var(--bg-1);
      padding: 0.5rem 1rem;
      border: none;
      border-radius: var(--border-radius);
  }

  :global(button:hover) {
      background: var(--link-hover);
  }

  button:active {
      background: var(--link-active);
  }

  :is(button, button:hover, button:active):disabled {
      background: var(--link);
      filter: grayscale(1);
      opacity: 0.4;
  }

  input,
  textarea,
  select {
      padding: 0.5rem;
      border: 1px solid var(--bg-2);
      border-radius: var(--border-radius);
      box-sizing: border-box;
  }

  input,
  textarea {
      background: var(--bg-1);
  }

  select:not([multiple]) {
      background: var(--bg-2);
  }

  textarea {
      font-family: var(--font-mono);
      font-size: 0.9rem;
  }

  form {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      align-items: baseline;
  }

  ul:has(li):has(form) {
      list-style: none;
      padding: 0;
  }

  li form {
      flex-direction: row;
      gap: 0.5rem;
      margin: 0.5rem 0;
  }

  nav {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 1em;
      padding: 1em;
      z-index: 2;
      margin: 0 0 1em 0;
      border-bottom: 2px solid #ffff;
      width:100%;
      padding-left: 10vw;
      padding-right: 10vw;
     

  }

  nav a {
      text-decoration: none;
  }

  nav a[aria-current='true'] {
      border-bottom: 2px solid;
  }

  .navbar a{
    margin: 10px;
  }

  ul:has(form) {
      list-style: none;
      padding: 0;
  }

  progress {
      margin: 0.5rem 0;
  }

  progress:first-child {
      margin-top: 0;
  }

  progress:last-child {
      margin-bottom: 0;
  }

  .error {
      color: red;
  }

  code {
      background: var(--bg-1);
      font-family: var(--font-mono);
      font-size: 0.9em;
      padding: 0.15rem 0.3rem;
      border-radius: var(--border-radius);
  }

  ul.todos {
      padding: 0;
  }

  ul.todos li:not(:has(> form)),
  ul.todos li form {
      position: relative;
      display: flex;
      align-items: center;
      padding: 0.5em 0.5em 0.5em 1em;
      margin: 0 0 0.5em 0;
      gap: 0.5em;
      border-radius: 5px;
      user-select: none;
      background: var(--bg-1);
      filter: drop-shadow(2px 3px 6px rgba(0, 0, 0, 0.1));
      transition: filter 0.2s, opacity 0.2s;
  }

  ul.todos .done {
      filter: none;
      opacity: 0.4;
  }

  ul.todos button {
      border: none;
      background-color: transparent;
      background-repeat: no-repeat;
      background-position: 50% 50%;
      background-size: 1rem 1rem;
      cursor: pointer;
      width: 3em;
      height: 3em;
      margin: -0.5em -0.5em -0.5em 0;
      aspect-ratio: 1;
      opacity: 0.5;
      transition: opacity 0.2s;
  }

  ul.todos button:hover {
      opacity: 1;
  }

  body.dark {
      --bg-1: hsl(0, 0%, 0%);
      --bg-2: hsl(0, 0%, 0%);
      --bg-3: hsl(0, 0%, 0%);
      --fg-1: hsl(0, 0%, 90%);
      --fg-2: hsl(0, 0%, 70%);
      --fg-3: hsl(0, 0%, 60%);
      --link: hsl(206, 96%, 72%);
      --link-hover: hsl(206, 96%, 78%);
      --link-active: hsl(206, 96%, 64%);
  }
 .content{
    width:80vw;
   /* overflow-y: auto; */
 }

 .outlined-button{
  padding: 10px 20px; 
  border: 2px solid #605DF9;
  border-radius: 20px; 
  background-color: black; 
  color: white; 
  font-size: 16px; 
  text-transform: uppercase; 
  cursor: pointer; 
  transition: all 0.3s ease; 
  margin:5px;
 }

 .filled-button{
  padding: 10px 20px; 
  border-radius: 20px; 
  border: 2px solid #605DF9;
  background-color: #605DF9; 
  color: white; 
  font-size: 16px; 
  text-transform: uppercase; 
  cursor: pointer; 
  transition: all 0.3s ease; 
  margin:5px;
 }

 .centered-content {
  display: flex;
  flex-direction: column; /* Stack items vertically */
  align-items: center; /* Center items horizontally */
  justify-content: center; /* Center items vertically */
  text-align: center; /* Ensures text within children is also centered, if needed */
 }


</style>
</svelte:head>

<script>
  import HeaderImage from '$lib/header_image.svelte'




  
  	import '../app.css';
  import {onMount} from "svelte";
    onMount(() => {
    // Ensure code runs only in the browser environment
    if (typeof window !== 'undefined') {
      const script = document.createElement('script');
      script.src = `${import.meta.env.VITE_API_URL}/static/memvp/transmittable_message.js`;
            script.async = true;
      script.onload = () => {
        console.log('Script loaded successfully');

        // Handle any actions that need to occur after the script is loaded
        // For example, accessing something now available on `window`
        // if (window.myLibrary) { ... }
      };
      script.onerror = (error) => {
        console.error('Script failed to load', error);
      };

      // Append the script to the document's head
      document.head.appendChild(script);

      // Optional: Remove the script when the component is destroyed
      // to clean up resources.
      // return () => {
      //   document.head.removeChild(script);
      // };
    }
  });
</script>

<div class="content">


<nav>

    

    <div class="logo">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100" zoomAndPan="magnify" viewBox="0 0 75 37.5" height="50" preserveAspectRatio="xMidYMid meet" version="1.0"><defs><g/><clipPath id="db7333c741"><path d="M 65.773438 9.992188 L 70.066406 9.992188 L 70.066406 14.285156 L 65.773438 14.285156 Z M 65.773438 9.992188 " clip-rule="nonzero"/></clipPath><clipPath id="7b8359ec35"><path d="M 67.917969 9.992188 C 66.734375 9.992188 65.773438 10.953125 65.773438 12.136719 C 65.773438 13.324219 66.734375 14.285156 67.917969 14.285156 C 69.105469 14.285156 70.066406 13.324219 70.066406 12.136719 C 70.066406 10.953125 69.105469 9.992188 67.917969 9.992188 Z M 67.917969 9.992188 " clip-rule="nonzero"/></clipPath></defs><g fill="#ffffff" fill-opacity="1"><g transform="translate(4.656661, 24.018065)"><g><path d="M 9.890625 -4.84375 C 9.890625 -4.570312 9.867188 -4.289062 9.828125 -4 L 3.328125 -4 C 3.367188 -3.414062 3.554688 -2.96875 3.890625 -2.65625 C 4.222656 -2.351562 4.628906 -2.203125 5.109375 -2.203125 C 5.828125 -2.203125 6.328125 -2.503906 6.609375 -3.109375 L 9.671875 -3.109375 C 9.515625 -2.492188 9.226562 -1.9375 8.8125 -1.4375 C 8.40625 -0.945312 7.894531 -0.5625 7.28125 -0.28125 C 6.664062 0 5.976562 0.140625 5.21875 0.140625 C 4.289062 0.140625 3.46875 -0.0546875 2.75 -0.453125 C 2.039062 -0.847656 1.484375 -1.410156 1.078125 -2.140625 C 0.671875 -2.867188 0.46875 -3.71875 0.46875 -4.6875 C 0.46875 -5.664062 0.664062 -6.519531 1.0625 -7.25 C 1.46875 -7.976562 2.023438 -8.535156 2.734375 -8.921875 C 3.453125 -9.316406 4.28125 -9.515625 5.21875 -9.515625 C 6.125 -9.515625 6.925781 -9.320312 7.625 -8.9375 C 8.332031 -8.5625 8.882812 -8.019531 9.28125 -7.3125 C 9.6875 -6.601562 9.890625 -5.78125 9.890625 -4.84375 Z M 6.9375 -5.59375 C 6.9375 -6.09375 6.769531 -6.488281 6.4375 -6.78125 C 6.101562 -7.070312 5.679688 -7.21875 5.171875 -7.21875 C 4.691406 -7.21875 4.285156 -7.078125 3.953125 -6.796875 C 3.628906 -6.515625 3.425781 -6.113281 3.34375 -5.59375 Z M 6.9375 -5.59375 "/></g></g></g><g fill="#ffffff" fill-opacity="1"><g transform="translate(15.014584, 24.018065)"><g><path d="M 0.46875 -4.703125 C 0.46875 -5.671875 0.648438 -6.519531 1.015625 -7.25 C 1.378906 -7.976562 1.875 -8.535156 2.5 -8.921875 C 3.132812 -9.316406 3.835938 -9.515625 4.609375 -9.515625 C 5.222656 -9.515625 5.785156 -9.382812 6.296875 -9.125 C 6.804688 -8.875 7.207031 -8.53125 7.5 -8.09375 L 7.5 -12.4375 L 10.375 -12.4375 L 10.375 0 L 7.5 0 L 7.5 -1.34375 C 7.226562 -0.894531 6.84375 -0.535156 6.34375 -0.265625 C 5.84375 0.00390625 5.265625 0.140625 4.609375 0.140625 C 3.835938 0.140625 3.132812 -0.0546875 2.5 -0.453125 C 1.875 -0.859375 1.378906 -1.425781 1.015625 -2.15625 C 0.648438 -2.894531 0.46875 -3.742188 0.46875 -4.703125 Z M 7.5 -4.6875 C 7.5 -5.40625 7.300781 -5.972656 6.90625 -6.390625 C 6.507812 -6.804688 6.023438 -7.015625 5.453125 -7.015625 C 4.878906 -7.015625 4.390625 -6.804688 3.984375 -6.390625 C 3.585938 -5.984375 3.390625 -5.421875 3.390625 -4.703125 C 3.390625 -3.984375 3.585938 -3.414062 3.984375 -3 C 4.390625 -2.582031 4.878906 -2.375 5.453125 -2.375 C 6.023438 -2.375 6.507812 -2.578125 6.90625 -2.984375 C 7.300781 -3.398438 7.5 -3.96875 7.5 -4.6875 Z M 7.5 -4.6875 "/></g></g></g><g fill="#ffffff" fill-opacity="1"><g transform="translate(26.431838, 24.018065)"><g><path d="M 10.3125 -9.375 L 10.3125 0 L 7.4375 0 L 7.4375 -1.28125 C 7.144531 -0.863281 6.75 -0.53125 6.25 -0.28125 C 5.75 -0.03125 5.195312 0.09375 4.59375 0.09375 C 3.875 0.09375 3.238281 -0.0625 2.6875 -0.375 C 2.132812 -0.695312 1.707031 -1.160156 1.40625 -1.765625 C 1.101562 -2.367188 0.953125 -3.082031 0.953125 -3.90625 L 0.953125 -9.375 L 3.8125 -9.375 L 3.8125 -4.28125 C 3.8125 -3.65625 3.972656 -3.164062 4.296875 -2.8125 C 4.628906 -2.46875 5.066406 -2.296875 5.609375 -2.296875 C 6.171875 -2.296875 6.613281 -2.46875 6.9375 -2.8125 C 7.269531 -3.164062 7.4375 -3.65625 7.4375 -4.28125 L 7.4375 -9.375 Z M 10.3125 -9.375 "/></g></g></g><g fill="#ffffff" fill-opacity="1"><g transform="translate(37.765012, 24.018065)"><g><path d="M 3.921875 -8.046875 C 4.203125 -8.484375 4.585938 -8.835938 5.078125 -9.109375 C 5.566406 -9.378906 6.144531 -9.515625 6.8125 -9.515625 C 7.582031 -9.515625 8.28125 -9.316406 8.90625 -8.921875 C 9.539062 -8.535156 10.035156 -7.976562 10.390625 -7.25 C 10.753906 -6.519531 10.9375 -5.671875 10.9375 -4.703125 C 10.9375 -3.742188 10.753906 -2.894531 10.390625 -2.15625 C 10.035156 -1.425781 9.539062 -0.859375 8.90625 -0.453125 C 8.28125 -0.0546875 7.582031 0.140625 6.8125 0.140625 C 6.15625 0.140625 5.578125 0.00390625 5.078125 -0.265625 C 4.585938 -0.535156 4.203125 -0.882812 3.921875 -1.3125 L 3.921875 4.46875 L 1.046875 4.46875 L 1.046875 -9.375 L 3.921875 -9.375 Z M 8.015625 -4.703125 C 8.015625 -5.421875 7.816406 -5.984375 7.421875 -6.390625 C 7.023438 -6.804688 6.535156 -7.015625 5.953125 -7.015625 C 5.378906 -7.015625 4.894531 -6.804688 4.5 -6.390625 C 4.101562 -5.972656 3.90625 -5.40625 3.90625 -4.6875 C 3.90625 -3.96875 4.101562 -3.398438 4.5 -2.984375 C 4.894531 -2.578125 5.378906 -2.375 5.953125 -2.375 C 6.523438 -2.375 7.007812 -2.582031 7.40625 -3 C 7.8125 -3.414062 8.015625 -3.984375 8.015625 -4.703125 Z M 8.015625 -4.703125 "/></g></g></g><g fill="#521bc3" fill-opacity="1"><g transform="translate(49.191764, 24.018065)"><g><path d="M 2.390625 0.140625 C 1.878906 0.140625 1.460938 -0.00390625 1.140625 -0.296875 C 0.828125 -0.597656 0.671875 -0.96875 0.671875 -1.40625 C 0.671875 -1.851562 0.828125 -2.226562 1.140625 -2.53125 C 1.460938 -2.84375 1.878906 -3 2.390625 -3 C 2.878906 -3 3.28125 -2.84375 3.59375 -2.53125 C 3.914062 -2.226562 4.078125 -1.851562 4.078125 -1.40625 C 4.078125 -0.96875 3.914062 -0.597656 3.59375 -0.296875 C 3.28125 -0.00390625 2.878906 0.140625 2.390625 0.140625 Z M 2.390625 0.140625 "/></g></g></g><g fill="#ffffff" fill-opacity="1"><g transform="translate(53.944796, 24.018065)"><g><path d="M 0.46875 -4.703125 C 0.46875 -5.671875 0.648438 -6.519531 1.015625 -7.25 C 1.378906 -7.976562 1.875 -8.535156 2.5 -8.921875 C 3.132812 -9.316406 3.835938 -9.515625 4.609375 -9.515625 C 5.265625 -9.515625 5.84375 -9.378906 6.34375 -9.109375 C 6.84375 -8.835938 7.226562 -8.484375 7.5 -8.046875 L 7.5 -9.375 L 10.375 -9.375 L 10.375 0 L 7.5 0 L 7.5 -1.328125 C 7.21875 -0.890625 6.828125 -0.535156 6.328125 -0.265625 C 5.828125 0.00390625 5.25 0.140625 4.59375 0.140625 C 3.832031 0.140625 3.132812 -0.0546875 2.5 -0.453125 C 1.875 -0.859375 1.378906 -1.425781 1.015625 -2.15625 C 0.648438 -2.894531 0.46875 -3.742188 0.46875 -4.703125 Z M 7.5 -4.6875 C 7.5 -5.40625 7.300781 -5.972656 6.90625 -6.390625 C 6.507812 -6.804688 6.023438 -7.015625 5.453125 -7.015625 C 4.878906 -7.015625 4.390625 -6.804688 3.984375 -6.390625 C 3.585938 -5.984375 3.390625 -5.421875 3.390625 -4.703125 C 3.390625 -3.984375 3.585938 -3.414062 3.984375 -3 C 4.390625 -2.582031 4.878906 -2.375 5.453125 -2.375 C 6.023438 -2.375 6.507812 -2.578125 6.90625 -2.984375 C 7.300781 -3.398438 7.5 -3.96875 7.5 -4.6875 Z M 7.5 -4.6875 "/></g></g></g><g fill="#ffffff" fill-opacity="1"><g transform="translate(65.36205, 24.018065)"><g><path d="M 2.484375 -10.359375 C 1.984375 -10.359375 1.570312 -10.503906 1.25 -10.796875 C 0.925781 -11.097656 0.765625 -11.46875 0.765625 -11.90625 C 0.765625 -12.351562 0.925781 -12.722656 1.25 -13.015625 C 1.570312 -13.316406 1.984375 -13.46875 2.484375 -13.46875 C 2.984375 -13.46875 3.390625 -13.316406 3.703125 -13.015625 C 4.023438 -12.722656 4.1875 -12.351562 4.1875 -11.90625 C 4.1875 -11.46875 4.023438 -11.097656 3.703125 -10.796875 C 3.390625 -10.503906 2.984375 -10.359375 2.484375 -10.359375 Z M 3.921875 -9.375 L 3.921875 0 L 1.046875 0 L 1.046875 -9.375 Z M 3.921875 -9.375 "/></g></g></g><g clip-path="url(#db7333c741)"><g clip-path="url(#7b8359ec35)"><path fill="#91248c" d="M 65.773438 9.992188 L 70.066406 9.992188 L 70.066406 14.285156 L 65.773438 14.285156 Z M 65.773438 9.992188 " fill-opacity="1" fill-rule="nonzero"/></g></g></svg>

    </div>
    <div class="navbar">
      <a href="/main/"> HOME </a>
      <!--    <OverflowMenu>-->
      <!--        <OverflowMenuItem href="/products/ap_calculus">AP Calculus</OverflowMenuItem>-->
      <!--        <OverflowMenuItem href="/products/evalugrade">Grade X | EvalUGrade</OverflowMenuItem>-->
      <!--    </Overflo <a href="/about"> ABOUT </a>
      <a href="/products/edugrade"> PRODUCT (Student)</a>
      <a href="/main/problem">PROBLEM</a>-->
      <a href="/main/about">ABOUT</a>
      <a href="/main/mission">MISSION</a>
      <!--a href="/products/evalugrade"> PRODUCT</a>
      <a-- href="/products/demo/hard_calculus">DEMO</a<-->
      <a href="/main/faqs">FAQS</a>
    </div>

   <div class="cta-button">
    <a href={`${import.meta.env.VITE_API_URL}/auth/login`}> <button class="outlined-button">Login</button></a>
    <a href={`${import.meta.env.VITE_API_URL}/auth/register`}><button class="filled-button">Get Started</button></a>
   </div>


  </nav>
  <!-- <HeaderImage></HeaderImage> -->
  <slot></slot>
</div>


<div style="width: 95vw; padding: 5vh; border-top: 2px solid white">

    <div class="socials-footer">
    



    </div>

    <p style="text-align: center;">Built with 💜 in Salt Lake City INJESTIV &copy; 2024</p>
    


</div>
